import React from 'react';

interface SummaryCardProps {
  totalCases: number;
  priorityBreakdown: {
    Top: number;
    High: number;
    Medium: number;
    Low: number;
    Non: number;
  };
}

const SummaryCard: React.FC<SummaryCardProps> = ({ totalCases, priorityBreakdown }) => {
  return (
    <div className="summary-card">
      <div className="total-cases">
        <h2>Total Active Cases</h2>
        <div className="total-number">{totalCases.toLocaleString()}</div>
      </div>
      
      <div className="priority-breakdown">
        <div className="priority-item">
          <span className="priority-label">Top</span>
          <span className="priority-value">{priorityBreakdown.Top}</span>
        </div>
        <div className="priority-item">
          <span className="priority-label">High</span>
          <span className="priority-value">{priorityBreakdown.High}</span>
        </div>
        <div className="priority-item">
          <span className="priority-label">Medium</span>
          <span className="priority-value">{priorityBreakdown.Medium}</span>
        </div>
        <div className="priority-item">
          <span className="priority-label">Low</span>
          <span className="priority-value">{priorityBreakdown.Low}</span>
        </div>
        <div className="priority-item">
          <span className="priority-label">Non</span>
          <span className="priority-value">{priorityBreakdown.Non}</span>
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;